'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _ConfigSelectors = require('pricing-pages-unified-ui/selectors/ConfigSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnvironmentWrapper = function EnvironmentWrapper(_ref) {
  var authedNode = _ref.authedNode,
      publicNode = _ref.publicNode,
      isAppAuth = _ref.isAppAuth;

  return isAppAuth ? authedNode : publicNode;
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAppAuth: (0, _ConfigSelectors.isAppAuthSelector)(state)
  };
};

EnvironmentWrapper.propTypes = {
  authedNode: _react2.default.PropTypes.node,
  publicNode: _react2.default.PropTypes.node,
  isAppAuth: _react2.default.PropTypes.bool.isRequired
};

EnvironmentWrapper.defaultProps = {
  authedNode: null,
  publicNode: null
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(EnvironmentWrapper);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/EnvironmentWrapper.js
// module id = 143
// module chunks = 3 4